<template>
  <div class="sf-network-error">
    <div class="container">
      <span v-if="!isOffline">
        <span class="sf-network-error__icon iconfont isummary-close"> </span>
        <span class="sf-network-error__text">
          Can not load the data, please try
          <a href="javascript:window.location.reload(true)">refreshing</a> the
          page.
        </span>
      </span>
      <span v-else>
        <span class="sf-network-error__icon iconfont isummary-close"> </span>
        <span class="sf-network-error__text"
          >It looks like you’re offline. Please connect to the Internet and try
          again.</span
        >
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { offline } from '@/services/offline'

const isOffline = computed(() => {
  return offline.isOffline
})
</script>
